/** Privacy policy — flat keys for onboardingT (privacy.title, …). */

function privacyFlat(obj) {
  const out = {};
  for (const [k, v] of Object.entries(obj)) {
    out[`privacy.${k}`] = v;
  }
  return out;
}

const PRIVACY_CONTENT = {
  ko: {
    title: '개인정보처리방침',
    section1Title: '수집하는 개인정보',
    section1Body:
      '밍고는 서비스 제공을 위해 다음 정보를 수집합니다.\n- 이름, 닉네임\n- 이메일 주소\n- 거주 국가 및 도시\n- 서비스 이용 기록\n- 기기 정보 (앱 푸시 알림용)',
    section2Title: '개인정보 이용 목적',
    section2Body:
      '수집한 정보는 다음 목적으로만 사용됩니다.\n- 서비스 제공 및 개선\n- 알림 발송\n- 고객 지원\n- 부정 이용 방지',
    section3Title: '개인정보 보관 기간',
    section3Body:
      '회원 탈퇴 시 모든 개인정보는 즉시 삭제됩니다.\n단, 관련 법령에 따라 일정 기간 보관이 필요한 정보는 예외로 합니다.',
    section4Title: '개인정보 제3자 제공',
    section4Body:
      '밍고는 유저의 동의 없이 개인정보를 제3자에게 제공하지 않습니다.\n법령에 의한 요청이 있는 경우는 예외입니다.',
    section5Title: '문의처',
    section5Body: '개인정보 관련 문의는 앱 내 고객지원 채널을 이용해주세요.',
    updated: '최종 업데이트',
  },
  en: {
    title: 'Privacy Policy',
    section1Title: 'Information We Collect',
    section1Body:
      'Mingo collects the following information.\n- Name, nickname\n- Email address\n- Country and city of residence\n- Service usage history\n- Device information (for push notifications)',
    section2Title: 'How We Use Your Information',
    section2Body:
      'Collected information is used only for:\n- Service provision and improvement\n- Notification delivery\n- Customer support\n- Fraud prevention',
    section3Title: 'Data Retention',
    section3Body:
      'All personal data is deleted upon account deletion.\nExceptions apply where required by law.',
    section4Title: 'Third-Party Sharing',
    section4Body:
      'Mingo does not share personal information without consent.\nExceptions apply to legally mandated disclosures.',
    section5Title: 'Contact',
    section5Body: 'For privacy inquiries, please use the in-app customer support channel.',
    updated: 'Last updated',
  },
  vi: {
    title: 'Chính sách quyền riêng tư',
    section1Title: 'Thông tin chúng tôi thu thập',
    section1Body:
      'Mingo thu thập các thông tin sau.\n- Tên, biệt danh\n- Địa chỉ email\n- Quốc gia và thành phố cư trú\n- Lịch sử sử dụng dịch vụ\n- Thông tin thiết bị (cho thông báo đẩy)',
    section2Title: 'Cách chúng tôi sử dụng thông tin',
    section2Body:
      'Thông tin thu thập chỉ được dùng cho:\n- Cung cấp và cải thiện dịch vụ\n- Gửi thông báo\n- Hỗ trợ khách hàng\n- Phòng chống gian lận',
    section3Title: 'Lưu trữ dữ liệu',
    section3Body:
      'Mọi dữ liệu cá nhân sẽ bị xóa khi xóa tài khoản.\nNgoại lệ theo quy định pháp luật.',
    section4Title: 'Chia sẻ với bên thứ ba',
    section4Body:
      'Mingo không chia sẻ thông tin cá nhân khi chưa có sự đồng ý.\nNgoại lệ theo yêu cầu pháp lý.',
    section5Title: 'Liên hệ',
    section5Body: 'Vui lòng dùng kênh hỗ trợ trong ứng dụng cho các câu hỏi về quyền riêng tư.',
    updated: 'Cập nhật lần cuối',
  },
  ru: {
    title: 'Политика конфиденциальности',
    section1Title: 'Какие данные мы собираем',
    section1Body:
      'Mingo собирает следующую информацию.\n- Имя, никнейм\n- Адрес электронной почты\n- Страна и город проживания\n- История использования сервиса\n- Информация об устройстве (для push-уведомлений)',
    section2Title: 'Как мы используем данные',
    section2Body:
      'Собранная информация используется только для:\n- Предоставления и улучшения сервиса\n- Отправки уведомлений\n- Поддержки пользователей\n- Предотвращения мошенничества',
    section3Title: 'Срок хранения',
    section3Body:
      'Все персональные данные удаляются при удалении аккаунта.\nИсключения — когда этого требует закон.',
    section4Title: 'Передача третьим лицам',
    section4Body:
      'Mingo не передаёт персональные данные без согласия.\nИсключения — случаи, предусмотренные законом.',
    section5Title: 'Контакты',
    section5Body: 'По вопросам конфиденциальности используйте канал поддержки в приложении.',
    updated: 'Последнее обновление',
  },
  ja: {
    title: 'プライバシーポリシー',
    section1Title: '収集する情報',
    section1Body:
      'Mingoは以下の情報を収集します。\n- 名前、ニックネーム\n- メールアドレス\n- 居住国・都市\n- サービス利用履歴\n- 端末情報（プッシュ通知用）',
    section2Title: '情報の利用目的',
    section2Body:
      '収集した情報は次の目的のみに使用します。\n- サービスの提供・改善\n- 通知の送信\n- カスタマーサポート\n- 不正利用の防止',
    section3Title: 'データの保管',
    section3Body:
      'アカウント削除時に個人データは削除されます。\n法令により保管が必要な場合を除きます。',
    section4Title: '第三者への提供',
    section4Body:
      'Mingoは同意なく個人情報を第三者に提供しません。\n法令に基づく場合を除きます。',
    section5Title: 'お問い合わせ',
    section5Body: 'プライバシーに関するお問い合わせはアプリ内サポートをご利用ください。',
    updated: '最終更新',
  },
  'zh-CN': {
    title: '隐私政策',
    section1Title: '我们收集的信息',
    section1Body:
      'Mingo 收集以下信息。\n- 姓名、昵称\n- 电子邮箱\n- 居住国家和城市\n- 服务使用记录\n- 设备信息（用于推送通知）',
    section2Title: '信息使用目的',
    section2Body:
      '收集的信息仅用于：\n- 提供和改进服务\n- 发送通知\n- 客户支持\n- 防止欺诈',
    section3Title: '数据保留',
    section3Body: '注销账户后，所有个人数据将被删除。\n法律要求保留的除外。',
    section4Title: '第三方共享',
    section4Body: '未经同意，Mingo 不会向第三方共享个人信息。\n法律要求的除外。',
    section5Title: '联系我们',
    section5Body: '隐私相关问题请通过应用内客服渠道联系。',
    updated: '最后更新',
  },
  'zh-TW': {
    title: '隱私權政策',
    section1Title: '我們收集的資訊',
    section1Body:
      'Mingo 收集以下資訊。\n- 姓名、暱稱\n- 電子郵件\n- 居住國家與城市\n- 服務使用紀錄\n- 裝置資訊（用於推播通知）',
    section2Title: '資訊使用目的',
    section2Body:
      '收集的資訊僅用於：\n- 提供與改進服務\n- 發送通知\n- 客戶支援\n- 防止詐欺',
    section3Title: '資料保留',
    section3Body: '刪除帳戶後，所有個人資料將被刪除。\n法律要求保留者除外。',
    section4Title: '第三方分享',
    section4Body: '未經同意，Mingo 不會向第三方分享個人資訊。\n法律要求者除外。',
    section5Title: '聯絡我們',
    section5Body: '隱私相關問題請透過應用程式內客服聯絡。',
    updated: '最後更新',
  },
  th: {
    title: 'นโยบายความเป็นส่วนตัว',
    section1Title: 'ข้อมูลที่เราเก็บรวบรวม',
    section1Body:
      'Mingo เก็บข้อมูลดังต่อไปนี้\n- ชื่อ, ชื่อเล่น\n- อีเมล\n- ประเทศและเมืองที่พำนัก\n- ประวัติการใช้บริการ\n- ข้อมูลอุปกรณ์ (สำหรับการแจ้งเตือน)',
    section2Title: 'การใช้ข้อมูล',
    section2Body:
      'ข้อมูลที่เก็บใช้เพื่อ:\n- ให้บริการและปรับปรุง\n- ส่งการแจ้งเตือน\n- สนับสนุนลูกค้า\n- ป้องกันการฉ้อโกง',
    section3Title: 'การเก็บรักษาข้อมูล',
    section3Body: 'ข้อมูลส่วนบุคคลจะถูกลบเมื่อลบบัญชี\nยกเว้นตามที่กฎหมายกำหนด',
    section4Title: 'การแบ่งปันกับบุคคลที่สาม',
    section4Body: 'Mingo ไม่แบ่งปันข้อมูลโดยไม่ได้รับความยินยอม\nยกเว้นตามกฎหมาย',
    section5Title: 'ติดต่อ',
    section5Body: 'สอบถามความเป็นส่วนตัวผ่านช่องทางสนับสนุนในแอป',
    updated: 'อัปเดตล่าสุด',
  },
  id: {
    title: 'Kebijakan Privasi',
    section1Title: 'Informasi yang kami kumpulkan',
    section1Body:
      'Mingo mengumpulkan informasi berikut.\n- Nama, nama panggilan\n- Alamat email\n- Negara dan kota tempat tinggal\n- Riwayat penggunaan layanan\n- Informasi perangkat (untuk notifikasi push)',
    section2Title: 'Cara kami menggunakan informasi',
    section2Body:
      'Informasi digunakan hanya untuk:\n- Penyediaan dan peningkatan layanan\n- Pengiriman notifikasi\n- Dukungan pelanggan\n- Pencegahan penipuan',
    section3Title: 'Penyimpanan data',
    section3Body: 'Data pribadi dihapus saat akun dihapus.\nKecuali jika diwajibkan oleh hukum.',
    section4Title: 'Berbagi dengan pihak ketiga',
    section4Body: 'Mingo tidak membagikan data tanpa persetujuan.\nKecuali jika diwajibkan oleh hukum.',
    section5Title: 'Kontak',
    section5Body: 'Untuk pertanyaan privasi, gunakan dukungan pelanggan di aplikasi.',
    updated: 'Terakhir diperbarui',
  },
  hi: {
    title: 'गोपनीयता नीति',
    section1Title: 'हम कौन सी जानकारी एकत्र करते हैं',
    section1Body:
      'Mingo निम्न जानकारी एकत्र करता है।\n- नाम, उपनाम\n- ईमेल पता\n- निवास देश और शहर\n- सेवा उपयोग इतिहास\n- डिवाइस जानकारी (पुश सूचनाओं के लिए)',
    section2Title: 'जानकारी का उपयोग',
    section2Body:
      'एकत्रित जानकारी केवल इनके लिए:\n- सेवा प्रदान और सुधार\n- सूचनाएँ\n- ग्राहक सहायता\n- धोखाधड़ी रोकथाम',
    section3Title: 'डेटा प्रतिधारण',
    section3Body: 'खाता हटाने पर सभी व्यक्तिगत डेटा हटा दिया जाता है।\nकानूनन आवश्यक अपवाद।',
    section4Title: 'तीसरे पक्ष के साथ साझा करना',
    section4Body: 'Mingo बिना सहमति के डेटा साझा नहीं करता।\nकानूनी आवश्यकता को छोड़कर।',
    section5Title: 'संपर्क',
    section5Body: 'गोपनीयता प्रश्नों के लिए ऐप में सहायता चैनल का उपयोग करें।',
    updated: 'अंतिम अपडेट',
  },
};

const COMMON_BACK = {
  ko: '뒤로',
  en: 'Back',
  vi: 'Quay lại',
  ru: 'Назад',
  ja: '戻る',
  'zh-CN': '返回',
  'zh-TW': '返回',
  th: 'กลับ',
  id: 'Kembali',
  hi: 'वापस',
};

export const PRIVACY_FLAT_BY_CODE = Object.fromEntries(
  Object.entries(PRIVACY_CONTENT).map(([code, obj]) => [
    code,
    { ...privacyFlat(obj), 'common.back': COMMON_BACK[code] || COMMON_BACK.ko },
  ]),
);
